import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@instructure/ui-heading';

const PageTitle = ({ title, margin, id }) =>
  <Heading
    margin={margin || '0 0 large'}
    level="h1"
    themeOverride={{
      h1FontWeight: 300
    }}
    id={id}
  >
    {title}
  </Heading>;

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  margin: PropTypes.string,
  id: PropTypes.string
};

export default PageTitle;
